import React, { useState } from 'react';
import Script from 'next/script';

import { IVideoBlockFullwidthFields } from '../../../types/contentful';

import { getImageData } from '../../utils/contentful';
import { trackWithFingerprint } from '../../utils/trackWithFingerprint';

import { Lightbox } from '../VideoBlock/Lightbox';
import { VideoContainerContent } from './VideoContainerContent';

import { BackgroundImage } from '../HomepageHero/styles';
import { VideoWrapper } from './styles';

export function VimeoVideo({
  title,
  vimeoId,
  backgroundImage,
  mobileButtonStyle,
  desktopButtonStyle
}: IVideoBlockFullwidthFields) {
  const [showingVideo, setShowingVideo] = useState(false);

  const toggleVideo = (displayVideo: boolean) => {
    setShowingVideo(displayVideo);
    if (displayVideo) {
      trackWithFingerprint('Video Opened', {
        page_url: window.location.href
      });
    } else {
      trackWithFingerprint('Video Closed', {
        page_url: window.location.href
      });
      document.getElementById('gl-video-play-button')?.focus();
    }
  };

  return (
    <VideoWrapper>
      <Script src="https://player.vimeo.com/api/player.js" />
      <BackgroundImage
        {...getImageData(backgroundImage)}
        layout="fill"
        objectFit="cover"
        width={undefined}
        height={undefined}
      />
      <div
        style={{
          position: 'relative',
          placeItems: 'center',
          display: 'grid'
        }}
      >
        <VideoContainerContent
          mobileButtonStyle={mobileButtonStyle}
          desktopButtonStyle={desktopButtonStyle}
          toggleVideo={toggleVideo}
        />

        {vimeoId && title && (
          <Lightbox
            title={title}
            showingVideo={showingVideo}
            setShowingVideo={toggleVideo}
            vimeoId={vimeoId}
          />
        )}
      </div>
    </VideoWrapper>
  );
}
